import { useRef, useState } from "react";
import EmojiPicker, { EmojiClickData } from "emoji-picker-react";

import styles from "../../../../assets/styles/componentStyles/templateLibraryStyles/emojiPickerButton.module.scss";

import InsertEmoticonOutlinedIcon from "@mui/icons-material/InsertEmoticonOutlined";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import GlobalTooltip from "../../../utility/tooltip/globalTooltip";

interface EmojiPickerButtonProps {
    disabled?: boolean;
    onSelectEmoji: (emoji: string, selection: { start: number; end: number } | null) => void;
    className?: string;
    textareaRef?: React.RefObject<HTMLTextAreaElement | null>;
    getTextareaElement?: () => HTMLTextAreaElement | null;
}

const EmojiPickerButton = ({ disabled = false, onSelectEmoji, className = "", textareaRef, getTextareaElement }: EmojiPickerButtonProps) => {
    
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const savedSelectionRef = useRef<{ start: number; end: number } | null>(null);

    const open = Boolean(anchorEl);

    const captureSelection = () => {
        const textarea = getTextareaElement?.() ?? textareaRef?.current ?? null;
        if (!textarea) {
            savedSelectionRef.current = null;
            return;
        }
        savedSelectionRef.current = {
            start: textarea.selectionStart ?? 0,
            end: textarea.selectionEnd ?? 0,
        };
    };

    const handleOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
        if (disabled) return;

        event.preventDefault();
        event.stopPropagation();
        captureSelection();

        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleEmojiClick = (emojiData: EmojiClickData) => {
        const selection = savedSelectionRef.current;
        // handleClose();
        onSelectEmoji(emojiData.emoji, selection);
    };

    return (
        <>
            <GlobalTooltip title={"Emoji"} placement="top" arrow enterTouchDelay={0} leaveTouchDelay={4000}>
                <IconButton
                    disableRipple
                    onMouseDown={(event) => {
                        if (disabled) return;
                        event.preventDefault();
                        captureSelection();
                    }}
                    onClick={handleOpen}
                    disabled={disabled}
                    className={`${styles.emojiButton} ${className}`}
                    size="small"
                >
                    <InsertEmoticonOutlinedIcon />
                </IconButton>
            </GlobalTooltip>

            <Menu
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                className={styles.emojiMenu}
                keepMounted
                transitionDuration={0}
                PopoverClasses={{
                    paper: styles.emojiMenu,
                }}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "left",
                }}
            >
                <EmojiPicker
                    width={280}
                    height={350}
                    onEmojiClick={handleEmojiClick}
                    searchPlaceholder="Search Emoji..."
                    skinTonesDisabled
                    previewConfig={{
                        showPreview: false,
                    }}
                />
            </Menu>
        </>
    );
};

export default EmojiPickerButton;